<template>
    <div class="detail" @click="clickCategory()">
        <h2>{{ item.title }}</h2>
        <div class="image">
            <div class="disabled-overlay" v-if="item.product_count == 0">
                <p>{{ label_na_for_your_vehicle }}</p>
            </div>
            <img :src="item.image" />
        </div>

        <div class="content">
            <p>{{ item.desc }}</p>
            <a :dusk="'begin_' + item.title" href="javascript:;" class="full-button btn btn-hover btn-primary" @click="$emit('showCategories')" v-if="item.product_count > 0">
                {{ label_begin }}
            </a>
<!--
            <h3 v-if="item.accessories">Accessories Include:</h3>
            <div class="clearfix">
                <ul v-if="item.accessories">
                    <li
                        v-for="(accessory, accessoryIndex) in item.accessories"
                        :key="accessoryIndex"
                    >
                        <img :src="accessory.icon_url" alt="">
                        <p>{{ accessory.translated }}</p>
                    </li>
                </ul>

                <p v-if="!item.accessories"></p>
            </div>
-->
        </div>
    </div>
</template>

<script>
export default {
    name: "solution-item",
    props: {
        item: Object,
        label_na_for_your_vehicle: {
            type: String,
            default: "Not available for your vehicle"
        },
        label_begin: {
            type: String,
            default: "Begin"
        },
    },
    methods: {
        clickCategory: function() {
            ga('send','event','Fit My Vehicle', 'Solution Item', this.item.title);
            gtag('event', 'fit_my_vehicle_solution_item', {'category':'Fit My Vehicle', 'action':"Solution Item", value: this.item.title});
            if (this.item.product_count > 0) {
                this.$emit('showCategories');
            }
        }
    }
};
</script>
